import { render, staticRenderFns } from "./DataSummaryChart.vue?vue&type=template&id=23915ca0&"
import script from "./DataSummaryChart.vue?vue&type=script&lang=js&"
export * from "./DataSummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports